export default __webpack_public_path__ + "static/media/landing.2c3bd926.jpg";